import { CreatorUrlType } from "./buildCreatorPublicUrl";
import {
  getCreatorPublicBaseUrl,
  type CreatorBrowsableUrlPrefs,
} from "./getCreatorPublicBaseUrl";

function resolveUrlType(
  browsableUrlPrefs?: CreatorBrowsableUrlPrefs | null,
): CreatorUrlType {
  if (browsableUrlPrefs?.urlType === "subdomain" || browsableUrlPrefs?.urlType === "path") {
    return browsableUrlPrefs.urlType;
  }
  try {
    const raw = localStorage.getItem("member");
    if (raw) {
      const parsed = JSON.parse(raw) as { url_type?: CreatorUrlType | null };
      if (parsed?.url_type === "subdomain" || parsed?.url_type === "path") {
        return parsed.url_type;
      }
    }
  } catch (_e) {
    // ignore
  }
  return "path";
}

/**
 * Public URL for a creator's full embed page (share link).
 * - Path style: `https://browsable.ai/embed/{username}`
 * - Subdomain / custom domain: `https://{host}/embed`
 */
export function getCreatorEmbedPublicUrl(args: {
  username: string;
  customDomain?: string | null | undefined;
  browsableUrlPrefs?: CreatorBrowsableUrlPrefs | null | undefined;
  isEmbedComponent?: boolean;
}): string {
  const username = String(args.username || "").trim();
  if (!username) return "";

  const base = getCreatorPublicBaseUrl(args);
  if (!base) return "";

  const encoded = encodeURIComponent(username);
  const urlType = resolveUrlType(args.browsableUrlPrefs);
  const isPathStyle = urlType === "path" && !args.customDomain;

  try {
    const url = new URL(base.startsWith("http") ? base : `https://${base}`);
    const pathSuffix = `/${encoded}`;

    if (
      isPathStyle ||
      url.pathname === pathSuffix ||
      url.pathname === `${pathSuffix}/`
    ) {
      return `${url.origin}/${args.isEmbedComponent ? "" :"embed" }/${encoded}`;
    }
    return `${url.origin}/${args.isEmbedComponent ? "" :"embed" }`;
  } catch {
    const normalized = base.replace(/\/+$/, "");
    if (isPathStyle) {
      return `${normalized}/embed/${encoded}`;
    }
    return `${normalized}/embed`;
  }
}
